import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { SMALL_HEADER_CONVERTER_TOKEN, SmallHeaderConverter } from './small-header.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        smallHeaderFeature: {
          module: () => import('./small-header.module').then((m) => m.SmallHeaderModule),
          cmsComponents: ['smallerheader'],
        },
      }
    }),
    {
      provide: SMALL_HEADER_CONVERTER_TOKEN,
      useExisting: SmallHeaderConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        smallerheader: SMALL_HEADER_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class SmallHeaderFeatureModule {}
